import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ibm-cloudnative-journey/ibm-cloudnative-journey/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Problem`}</h2>
    <p>{`The Hyper Drive isn’t working and we need to find out why. Let’s debug the `}<inlineCode parentName="p">{`hyper-drive`}</inlineCode>{` deployment so that we can reach light speed again.`}</p>
    <p>{`Here are some tips to help you solve the Hyper Drive:`}</p>
    <ul>
      <li parentName="ul">{`Check the description of the `}<inlineCode parentName="li">{`deployment`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`Get and save the logs of one of the broken `}<inlineCode parentName="li">{`pods`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`Are the correct `}<inlineCode parentName="li">{`ports`}</inlineCode>{` assigned.`}</li>
      <li parentName="ul">{`Make sure your `}<inlineCode parentName="li">{`labels`}</inlineCode>{` and `}<inlineCode parentName="li">{`selectors`}</inlineCode>{` are correct.`}</li>
      <li parentName="ul">{`Check to see if the `}<inlineCode parentName="li">{`Probes`}</inlineCode>{` are correctly working.`}</li>
      <li parentName="ul">{`To fix the deployment, save then modify the yaml file for redeployment.`}</li>
    </ul>
    <p>{`Reset the environment:`}</p>
    <pre><code parentName="pre" {...{}}>{`minikube delete
minikube start
`}</code></pre>
    <p>{`Setup the environment:`}</p>
    <pre><code parentName="pre" {...{}}>{`kubectl apply -f https://raw.githubusercontent.com/ibm-cloud-architecture/learning-cloudnative-101/master/lab-setup/lab-5-debug-k8s-setup.yaml
`}</code></pre>
    <h2>{`Validate`}</h2>
    <p>{`Once you get the Hyper Drive working again. Verify it by checking the endpoints.`}</p>
    <pre><code parentName="pre" {...{}}>{`kubectl get ep hyper-drive
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      